import React, { ReactElement } from 'react';
import {
  Select,
  SortLink,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  usePerPageValueFromUrl,
} from 'idsk-react-components';
import { Pagination, useResponsiveContext } from 'slovlex-idsk-react-components';
import { useSearchParams } from 'react-router-dom';
import TerminHistoriaZmienPage from '../../../../model/TerminHistoriaZmienPage';
import showTotalNumberOfElements from '../../../../functions/showTotalNumberOfElements';
import { perPageDataArray } from '../../../../constants/PaginationPerPageConstants';
import { mapDateTime } from '../../../../functions/mapDate';
import './terminHistoriaZmien.scss';

interface Props {
  terminHistoriaZmienPage?: TerminHistoriaZmienPage | null;
  pageNumberFromUrl: number;
}

const TerminHistoriaZmien = ({
  terminHistoriaZmienPage,
  pageNumberFromUrl,
}: Props): ReactElement => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray);
  const { isSmallScreen } = useResponsiveContext();

  const handlePerPageValueChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = parseInt(e.target.value, 10);
    const updatedSearchParams = new URLSearchParams(searchParams.toString());
    updatedSearchParams.set('perPage', value.toString());
    setSearchParams(updatedSearchParams.toString());
  };

  if (!terminHistoriaZmienPage) {
    return <></>;
  }

  if (terminHistoriaZmienPage.totalElements === 0) {
    return <p className="text-center">Termín nemá evidovanú žiadnu históriu zmien.</p>;
  }

  return (
    <div className="historia-zmien-table">
      {isSmallScreen && perPageDataArray.length > 0 && (
        <div className="combo-box--wrapper">
          <span className="pagination-span">Na stranu</span>{' '}
          <Select
            value={perPageValue}
            onChange={handlePerPageValueChange}
            className="combo-box"
          >
            {perPageDataArray.map((value) => (<option key={value}>{value}</option>))}
          </Select>
        </div>
      )}
      <div className="total-sort-container">
        <Text className="total-label">{showTotalNumberOfElements(terminHistoriaZmienPage)}</Text>
      </div>
      <Table>
        <Thead>
          <Tr>
            <Th>
              <SortLink
                propertyName="datumZmeny"
                defaultDirection="asc"
                linkColor="black"
                doubleArrows
              >Dátum a čas
              </SortLink>
            </Th>
            <Th>Autor zmeny</Th>
            <Th>Typ zmeny</Th>
          </Tr>
        </Thead>
        <Tbody>
          {terminHistoriaZmienPage.historiaZmienList.map(historiaZmien => (
            <Tr key={historiaZmien.uuid}>
              <Td>
                {mapDateTime(historiaZmien.datum)}
              </Td>
              <Td>
                {historiaZmien.autor}
              </Td>
              <Td>
                {historiaZmien.typ}{historiaZmien.oblast && (
                  <>
                    , {historiaZmien.oblast}
                  </>
                )}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      <Pagination
        number={pageNumberFromUrl}
        size={terminHistoriaZmienPage.size}
        totalElements={terminHistoriaZmienPage.totalElements}
        onRecordsPerPageChange={(value) => {
          const updatedSearchParams = new URLSearchParams(searchParams.toString());
          updatedSearchParams.set('perPage', value.toString());
          setSearchParams(updatedSearchParams.toString());
        }}
        recordsPerPage={perPageDataArray}
        perPageValue={perPageValue}
        hideTotal
      />
    </div>
  );
};

export default TerminHistoriaZmien;
